import { composeEffects } from '../module';
import { transport } from '../transport';
import { IUser } from '../types';

import { userActionCreators } from './actionsAndReducer';

export const userEffects = composeEffects('user', (compose) => {
  return {
    getByEntityId: compose.effect(async (params: { entityId: number; limit?: number }) => {
      return transport
        .url('/api/v1/users')
        .query({
          entity_id: params.entityId,
          limit: params.limit || 32,
          fields: ['id', 'first_name', 'last_name', 'full_name', 'email', 'uuid'].join(',')
        })
        .get()
        .json()
        .then((response: { users: IUser[] }) => {
          userActionCreators.loadingUsersSuccess(response.users);
          return response.users;
        });
    }),
    getByUuid: compose.effect(async (params: { uuid: string }) => {
      return transport
        .url(`/api/v1/users/${params.uuid}`)
        .query({ fields: ['id', 'first_name', 'last_name', 'full_name', 'email', 'uuid'].join(',') })
        .get()
        .json()
        .then((response: IUser) => {
          if (!response.uuid) {
            throw new Error(`Corrupted api response for getting user by uuid=${params.uuid}`);
          }
          return response;
        });
    })
  };
});
